export default "__VITE_ASSET__QzL2ZolE__"